import Entity from "../entity";

export default class OfferDateSlot extends Entity<number> {
  startDate: Date;
  endDate: Date;
}
